import { FormationDetail } from '../../types/services';
import { themeColors } from '../../utils/colors';
import ClaudeLogo from '@/assets/Claude-ai-logo.png';
import ChatgptLogo from '@/assets/chatgpt-logo-white.png';

export class FormationDataProvider {
  public static getFormationData(): FormationDetail[] {
    return [
      // Formation IA - Fondamentaux (existante, conservée)
      {
        id: 'ia-fondamentaux',
        title: 'Fondamentaux de l\'IA',
        duration: '2H30',
        level: 'Débutant',
        audience: 'Dirigeants, Managers, Équipes métier, Collaborateurs',
        description: "Comprendre les principes de base de l'intelligence artificielle et son impact sur votre secteur d'activité.",
        modules: [
          "Introduction aux concepts clés de l'IA :<br> Présentation des bases de l'intelligence artificielle, y compris l'apprentissage automatique et le traitement du langage naturel.",
          "Panorama des meilleurs IA : <br>Exploration des outils d'IA populaires tels que ChatGPT, claude.ai, mistral, midjourney, perplexity.",
          "Étude de cas et retours d'expérience : <br>Analyse de cas réels pour comprendre l'application pratique de l'IA dans divers secteurs."
        ],
        benefits: [
          "Vision claire des possibilités offertes par l'IA",
          "Capacité à identifier les cas d'usage pertinents",
          "Démystification des technologies d'IA",
        ],
        icon: 'M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253',
        featureColor: themeColors['won-teal']
      },
      
      // Nouvelle formation - Découvrir et comparer les meilleures IA
      {
        id: 'diverses-ia',
        title: 'Découvrir et comparer les meilleures IA',
        duration: '2h',
        level: 'Tous niveaux',
        audience: 'Professionnels tous secteurs, Managers, Collaborateurs',
        description: "Comparer et maîtriser les meilleurs outils d'IA pour gagner en efficacité au quotidien.",
        modules: [
          "Introduction à l'IA appliquée au travail : <br>Panorama des technologies et applications pratiques.",
          "Présentation des outils incontournables : <br>ChatGPT, Microsoft Copilot, Perplexity, Gamma, Claude - forces et limites.",
          "Exploration des interfaces : <br>Prise en main pratique des différentes plateformes d'IA.",
          "Premiers cas pratiques comparés : <br>Rédaction de résumés, création de présentations, automatisation de rapports.",
          "Recherches complexes et synthèses : <br>Techniques de recherche avec sources fiables sur différents outils.",
          "Analyse de données et tableaux de bord : <br>Utilisation des IA pour interpréter et visualiser des données.",
          "Création de contenu pour la communication : <br>Rédaction optimisée pour LinkedIn, newsletters et emails clients.",
          "Travail collaboratif et automatisation : <br>Création de notes, trames de réunion et plans d'action."
        ],
        benefits: [
          "Vision claire des forces et limites de chaque outil d'IA",
          "Capacité à choisir l'outil le plus adapté à chaque tâche",
          "Optimisation des workflows quotidiens",
          "Méthodes pratiques d'intégration des IA dans le travail"
        ],
        icon: 'M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4',
        featureColor: themeColors['won-emerald']
      },
      // Formation ChatGPT (mise à jour avec le nouveau contenu)
      {
        id: 'ia-chatgpt',
        title: 'ChatGPT - Usages professionnels',
        duration: '2h',
        level: 'Tous niveaux',
        audience: 'Professionnels tous secteurs, Managers, Collaborateurs',
        description: "Se perfectionner avec ChatGPT : maîtriser les usages professionnels de l'IA conversationnelle.",
        modules: [
          "Introduction à l'IA et aux IA conversationnelles : <br>Principes fondamentaux, fonctionnement de base des modèles de langage.",
          "Découverte de ChatGPT et prise en main : <br>Interface, versions, fonctionnalités de base et navigation.",
          "Création de prompts efficaces : <br>Techniques pour formuler des instructions précises et obtenir des résultats pertinents.",
          "Cas pratiques quotidiens : <br>Rédaction de notes, préparation de calendriers de publication, réponses aux clients.",
          "Fonctionnalités avancées : <br>Recherche approfondie, planification, génération de canevas, création d'images, usage de SORA.",
          "Cas pratiques approfondis : <br>Rédaction d'articles, résumé de contenus, analyse de documents et de données.",
          "Création d'un GPT personnalisé : <br>Conception d'un assistant sur mesure adapté aux besoins spécifiques d'un cabinet."
        ],
        benefits: [
          "Gain de temps significatif sur les tâches quotidiennes",
          "Amélioration de la qualité des productions écrites",
          "Capacité à automatiser des processus répétitifs",
          "Création d'un assistant IA personnalisé"
        ],
        icon: ChatgptLogo,
        featureColor: themeColors['won-pink']
      },
      {
        id: 'ia-claude',
        title: 'Claude - Usages professionnels',
        duration: '2h',
        level: 'Tous niveaux',
        audience: 'Professionnels tous secteurs, Managers, Collaborateurs',
        description: "Maîtriser Claude pour booster l’efficacité professionnelle : découvrez comment exploiter au mieux cette IA conversationnelle innovante.",
        modules: [
          "Introduction à Claude et à l’IA conversationnelle : <br>Principes de fonctionnement, différences avec d'autres modèles d’IA, philosophie d’Anthropic.",
          "Prise en main de Claude : <br>Découverte de l’interface, versions disponibles, options de personnalisation et gestion de la confidentialité.",
          "Élaboration de prompts performants : <br>Méthodes pour formuler des requêtes pertinentes et tirer parti des forces spécifiques de Claude.",
          "Cas d’usages concrets : <br>Gestion des emails, synthèse de réunions, génération de rapports, automatisation des notes de service.",
          "Exploration des fonctionnalités avancées : <br>Analyse de documents volumineux, création de résumés complexes, extraction de données, intégration avec outils métiers.",
          "Cas pratiques approfondis : <br>Rédaction de documents stratégiques, analyse comparative, préparation de présentations professionnelles.",
          "Personnalisation de Claude pour son organisation : <br>Définir des rôles, paramétrer des comportements sur-mesure, bonnes pratiques de gouvernance IA."
        ],
        benefits: [
          "Optimisation du temps sur les tâches administratives et analytiques",
          "Amélioration de la qualité et de la pertinence des analyses",
          "Automatisation intelligente des processus métier",
          "Capacité à manipuler et synthétiser de grands volumes de données textuelles"
        ],
        icon: ClaudeLogo,
        featureColor: themeColors['won-blue']
      },
      {
        id: 'crypto-actifs',
        title: 'Crypto-actifs & comptabilité',
        duration: '1 jour',
        level: 'Intermédiaire',
        audience: 'Comptables, Experts-comptables, Directeurs financiers',
        description: "Maîtriser les fondamentaux des crypto-actifs et sécuriser les traitements comptables.",
        modules: [
          "Comprendre les crypto-actifs et la Blockchain : <br>Origine, fonctionnement, types d'actifs (utility tokens, security tokens, NFTs) et cas d'usage.",
          "Identifier les risques : <br>Localisation des wallets, contrôle interne (gestion des clés privées, procédures), politique de conversion.",
          "Connaître les obligations déclaratives : <br>Obligations PSAN, qualification PSAN, agrément AMF, Loi 2025-127 (articles 54 & 59).",
          "Appliquer les règles comptables : <br>Règlement ANC 2020-05, format des fichiers, calcul des plus/moins-values, schémas d'écritures.",
          "Cas pratique : <br>Manipulation de fichiers et leur retranscription en écritures comptables."
        ],
        benefits: [
          "Maîtrise technique des crypto-actifs et de la blockchain",
          "Sécurisation des traitements comptables des crypto-actifs",
          "Conformité avec les réglementations en vigueur",
          "Application pratique des règles comptables ANC"
        ],
        icon: 'M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z',
        featureColor: themeColors['won-pink-light']
      },
      // Formation Midjourney (existante, conservée)
      // {
      //   id: 'ia-business',
      //   title: 'Libérez votre créativité avec MidJourney',
      //   duration: '1H30',
      //   level: 'Débutant/Intermédiaire',
      //   audience: 'Professionnels du marketing, Communication, RH, Support client, Collaborateurs',
      //   description: "Comprendre Midjourney, l'IA qui transforme vos idées en images",
      //   modules: [
      //     "Introduction à l'Interface : <br>Découverte de l'interface utilisateur de MidJourney et familiarisation avec les fonctionnalités de base.",
      //     "Construction de prompts : <br>Apprentissage des techniques pour formuler des prompts efficaces afin d'obtenir des résultats visuels précis et conformes à vos attentes.",
      //     "Appliquer des variations : <br>Exploration des options de variation pour générer plusieurs interprétations d'une même idée et choisir la meilleure version.",
      //     "Upscale avec U1 à U4 : <br>Utilisation des options d'upscale pour améliorer la résolution et la qualité des images générées, en fonction des besoins du projet.",
      //     "Zoom et recadrage : <br>Techniques pour zoomer et recadrer les images afin de mettre en valeur des détails spécifiques ou d'adapter le format à différents supports.",
      //     "Editer avec MidJourney : <br>Initiation aux outils d'édition intégrés pour retoucher et personnaliser les images générées, afin de les adapter parfaitement à vos besoins créatifs."
      //   ],
      //   benefits: [
      //     "Création rapide de visuels uniques et de haute qualité pour vos projets",
      //     "Maîtrise des techniques de prompting pour obtenir des résultats précis",
      //     "Optimisation des processus créatifs grâce à l'IA",
      //     "Capacité à adapter et à personnaliser les visuels selon vos besoins"
      //   ],
      //   icon: 'M9 17V7m0 10a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2h2a2 2 0 012 2m0 10a2 2 0 002 2h2a2 2 0 002-2M9 7a2 2 0 012-2h2a2 2 0 012 2m0 10V7m0 10a2 2 0 002 2h2a2 2 0 002-2V7a2 2 0 00-2-2h-2a2 2 0 00-2 2',
      //   featureColor: themeColors['won-blue']
      // },
      


      
      // Formation RGPD (existante, conservée)
      {
        id: 'RGPD',
        title: 'RGPD',
        duration: 'demi journée',
        level: 'Tous niveaux',
        audience: 'Dirigeants, Managers, Équipes marketing, Communication, Commercial, Collaborateurs',
        description: "Maîtrisez les fondamentaux du RGPD et développez une stratégie efficace de protection des données personnelles.",
        modules: [
          "Évaluer l'impact du RGPD sur votre organisation interne.",
          "Comprendre les étapes clés pour assurer la conformité au RGPD : <br>Identification des actions nécessaires pour se conformer aux exigences du RGPD.",
          "Cartographier et recenser les traitements de données personnelles existants.",
          "Mettre en place un registre de traitement pour organiser vos données.",
          "Respecter les droits des personnes administrées (informer et organiser) : <br>Mise en œuvre des mesures pour respecter les droits des individus.",
          "Sécuriser vos données : Adoption de mesures de sécurité pour protéger les données personnelles."
        ],
        benefits: [
          "Renforcement de la confiance des clients grâce à une gestion conforme des données",
          "Optimisation des processus marketing en respectant les réglementations",
          "Amélioration de la transparence et de la communication avec les utilisateurs",
          "Réduction des risques juridiques liés à la non-conformité au RGPD"
        ],
        icon: 'M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z',
        featureColor: themeColors['won-orange']
      },
      
      // Formation Facture Électronique (existante, conservée)
      {
        id: 'facture-electronique',
        title: 'Facture Électronique',
        duration: 'demi journée',
        level: 'Intermédiaire',
        audience: 'Analystes, Managers, Chefs d entreprise, Collaborateurs',
        description: "Se préparer à la facture électronique : enjeux et solutions clés",
        modules: [
          "Comprendre les enjeux et le périmètre de la facture électronique pour les entreprises : <br>Analyse des avantages et des défis liés à l'adoption de la facturation électronique.",
          "Le calendrier des obligations légales et les délais à respecter.",
          "Identifier le fonctionnement de l'écosystème et le rôle de chacun : PDP, PFF, OD.",
          "Découvrir les principaux impacts sur l'organisation de l'entreprise."
        ],
        benefits: [
          "Préparation efficace à la transition vers la facturation électronique",
          "Réduction des erreurs et des coûts associés à la gestion des factures",
          "Conformité aux exigences légales et réglementaires en matière de facturation"
        ],
        icon: 'M16 8v8m-4-5v5m-4-2v2m-2 4h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z',
        featureColor: themeColors['won-blue-dark']
      },
      
      // Nouvelle formation - Crypto-actifs & comptabilité

    ];
  }
}